import { useEffect, useMemo, useState } from 'react';

import { AffiliateBaseThemeType, ChatBaseThemeType, createTheme } from '@repo/styles';
import { checkIsInBubbleTapApp, useService } from '@repo/utils';

// export default function useTheme<T extends AppTheme>(baseTheme: T) {
//   const [isDarkMode, setIsDarkMode] = useState(document.body.classList.contains('dark'));

//   useEffect(() => {
//     const handleDarkModeToggle = () => {
//       setIsDarkMode(document.body.classList.contains('dark'));
//     };

//     const observer = new MutationObserver(handleDarkModeToggle);
//     observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

//     return () => {
//       observer.disconnect();
//     };
//   }, []);
//   const theme = useMemo(() => createTheme(isDarkMode ? 'dark' : 'light', baseTheme), [isDarkMode, baseTheme]);

//   return { theme };
// }

export default function useTheme<T extends ChatBaseThemeType | AffiliateBaseThemeType>(
  baseTheme: T,
  options?: { forceLightMode?: boolean }
) {
  const { serviceName } = useService();
  const isOnlyDark = ['tingle'].includes(serviceName);
  const isBubbleTapApp = checkIsInBubbleTapApp();

  const shouldForceDarkMode = !options?.forceLightMode && (isBubbleTapApp || isOnlyDark);

  const [isDarkMode, setIsDarkMode] = useState(shouldForceDarkMode ? true : document.body.classList.contains('dark'));

  useEffect(() => {
    if (shouldForceDarkMode) {
      setIsDarkMode(true);
      return;
    }

    const handleDarkModeToggle = () => {
      setIsDarkMode(document.body.classList.contains('dark'));
    };

    const observer = new MutationObserver(handleDarkModeToggle);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => {
      observer.disconnect();
    };
  }, [shouldForceDarkMode]);

  const theme = useMemo(() => createTheme(isDarkMode ? 'dark' : 'light', baseTheme), [isDarkMode, baseTheme]);

  return { theme };
}
